import * as React from 'react';
import GamePageLayout from '../components/GamePageLayout';
import Footer from '../components/Footer/Footer';
import {showLoading,Util,Button,closeDialog, showCustomDialog,showErrorDialog} from 'baziigram'
import {navigate} from "gatsby-link";
import {useDispatch, useSelector} from "react-redux";
import {persist} from "../redux/actions";
import {HOME_ACTION_PERSIST,HOME_ACTION_CLEAR} from "../redux/Home/home.constant";
import Slider from "react-slick";
import {STORAGE_KEY} from "../constants";
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import GameNavbar from "../components/GameNavbar";
import GameHeader from "../components/GameHeader";
import appService from '../Service'
import {useEffect, useState} from "react";
import Metrix from '../Util/metrix'
import {dictionary} from '../constants'
import {openForgetDialog , showDailyCoinDialog} from '../Handlers/Dialogs'
import {GetUser , UpdateUser} from "../Util/user"
import {showAds} from "../Util/Ads"
const IndexPage = () => {

  const { games  ,error , banners  , user , isStandalone  ,
        language , direction ,categories  , category , gameId } = useSelector(state => state.home);

  const dispatch = useDispatch();
  const defaultCategory = {name:dictionary.all[Util.getLanguage()],id:0};
  const updateState=(state)=>{
    dispatch(persist(state, HOME_ACTION_PERSIST))
       }

  var gameanalytics = typeof window !== `undefined`? require('gameanalytics'):null;
  const isMounted = React.useRef(false)
  const  pairs = Util.extractQuery()
  const settings = {
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows:false
    };


  React.useEffect(()=>{
  const l = Util.getLanguage();
   updateState({isStandalone:(Util.Platform.isStandalone() || pairs["utm_campaign"]=="androidApp" || pairs["utm_campaign"]=="notif"),
    user:null ,  language:l , direction:l=="fa" ? "rtl" :"ltr", categories:null  ,
    category:defaultCategory , gameId:pairs["gameId"]
    })

   let u=GetUser()
   updateState({user:u})
      getBanners();
     GetGameCategories();
    if(pairs['utm_campaign'] && pairs['utm_campaign'].indexOf('socialshare')>-1)
    appService.UnlockUser(pairs['utm_campaign'].replace("socialshare","")).then(res=>{}).catch(err=>{})
  },[])


  const GetGameCategories=()=>{
  appService.GetGameCategories().then(res=>{
  updateState({categories:[defaultCategory].concat(res.list)})
  }).catch(err=>{ })
  }

  const recordLog=()=>{
  appService.RecordSiteView(pairs['utm_campaign'] || "direct").then(res=> {
        if (res.dailyCoin > 0)
        showDailyCoinDialog(res.dailyCoin)

        if(res.user)
        {
        UpdateUser(res.user);
        updateState({user:GetUser()});
         LoadGameOffers();
        }

      }).catch(err=>{
      showErrorDialog(err.message || err)
       })
  }


  useEffect(()=>{
   /*  Metrix.initialize({
      appId: 'dzyjtcxvcykvbhr',
      uniqueDeviceId: Util.generateUUid(),
     });
*/
  },[])

  useEffect(()=>{
 setTimeout(scrollToGames,1000)
  },[category])

useEffect(()=>{

if(isMounted.current==false && games!=null)
   {
   if(window.android)
    {try{ appService.FCMToken().then(res=>{}).catch(err=>{}) }
     catch(err){}
     }
     if(gameId)
       {let game = games.allGames.filter(item=>item.id==gameId)[0]
         if(game)
         goToGame(game.link)
       }
       recordLog()
      isMounted.current = true
   return
    }

  if(games==null)
     loadGames();


  },[games])



 const handleClickGame=(route)=>{
 showAds(()=>goToGame(route));

 }

  const goToGame=(route)=>{
    if(typeof window !== `undefined`) {
    let query = route.split("?gameId=")
    if(query.length>1)
      {let game = query[1].split("&")[0]
      gameanalytics.GameAnalytics.addProgressionEvent(gameanalytics.EGAProgressionStatus.Start,
          game, null, null, user);
          }
    }
    if(route.indexOf("http")>-1)
    navigate("/WebView",{state:{url:route , backUrl:"/"}})

    else
    navigate(route)
  }

  const loadGames=()=>{
    updateState({error:null})
    appService.GetGamesList().then(res=>{
       updateState({games: res  , category:defaultCategory})

    }).catch(err=>{

      updateState({error:dictionary.retryText[language]})
    })
  }

const LoadGameOffers=()=>
{
appService.GameOffers().then(res=>{
     updateState({games:Object.assign({},{"offers":res.list} , games) })

}).catch(err=>{
console.error(err.message)
})
}

  const getBanners=()=>{
    appService.GetBanners().then(res=>{
   updateState({banners:res.list})
   }).catch(err=>{
   console.error(err.message)
     })
  }




const scrollToGames=()=>{
try{
 document.getElementById('games').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
 }
 catch(err){}
}

  const closeInstallApp=(e)=>{
     if(e.target.id=="installAppContainer")
     {updateState({isStandalone:true})
     }

  }

const getDeveloperInfo=(devId)=>{
showLoading(true)
    appService.GetDeveloperInfo(devId).then(res=>{
   openDeveloperInfo(res.info)
    }).catch(err=>{
    showErrorDialog(err.message || err);

    }).finally(err=>{
    showLoading(false)
    })
}

  const openDeveloperInfo=(info)=>{
   let body = <div style={{lineHeight:"30px"}} className={'d-flex flex-column align-items-center justify-content-between'}>
        <div className={"d-flex flex-row justify-content-between w-100"}>
          <button
              type="button"
              className="close"
              onClick={closeDialog}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className={"rtl my-2 d-flex flex-column justify-content-start align-items-end w-100"}>
          {info.photo && <img className="mx-auto" style={{borderRadius:"8px"}} src={info.photo} width={"100px"}/>}
           <h2 className="w-100 text-center">{info.name}</h2>
           </div>
         <div className={"my-2 d-flex flex-row justify-content-center align-items-center w-100"}>
           {info.git && <button onClick={()=>window.open(info.git)}>{dictionary.git[language]}<img className="mx-2" src={"/images/icons/github3.png"} width={"40px"}/></button>}
            {info.linkedin && <button onClick={()=>window.open(info.linkedin)}>{dictionary.linkedin[language]} <img className="mx-2" src={"/images/icons/linkedin3.png"} width={"40px"}/></button>}
             </div>

      </div>


      showCustomDialog(body)
  }

const renderGameItem=(game)=>{
  let stars = Array.from('x'.repeat(parseInt(game.stars)))
   return <div  onClick={()=>handleClickGame(game.link)}  className={"new-grid-Items d-flex flex-column align-items-center"}>
          <img style={{maxWidth:"100px"}} className={"game-Icons-square"} src={game.logo}/>
          <div className="mb-2  d-flex flex-column justify-content-between align-items-center w-100 rtl">
          <p className={"game-title  w-100 my-1 text-center"}> {game.name} </p>
          <div className={" w-100 my-1 d-flex flex-row justify-content-center"}>{stars.map(i=>(<img src={"/images/icons/star5.png"}  className="mr-1" height={"10px"} width={"10px"} />))}</div>
            </div>
          {game.developerId>0 && <div style={{height:"40px"}} className="d-flex flex-row justify-content-start aligh-items-center">
           <button className="m-0 p-0" onClick={(e)=>{e.stopPropagation();getDeveloperInfo(game.developerId)}}>
          <img className="mx-1" src={"/images/icons/profileIcon.png"} width={"40px"}/>
          </button>
         <p className="pt-1"> {dictionary.developerInfo[language]} </p>
          </div>}

     </div>

}



  return (
      <GamePageLayout type={HOME_ACTION_CLEAR}>
        {!isStandalone &&  <div id={"installAppContainer"} onClick={closeInstallApp} className={"installAppContainer"}><div class={"installApp"}>
          <div className={`d-flex flex-row justify-content-between align-items-center ${direction}`}>
            <div className={`d-flex flex-row justify-content-start align-items-center ${direction}`}>
                <img className={"ml-2"} width={"50px"} src={"./images/icons/neon2nahai 2 (1).png"}/>
              <div style={{fontSize:"0.9rem"}} className={"d-flex flex-column justify-content-start align-items-start mx-2"}>
                <div>{dictionary.app[language]}</div>
                <div>{dictionary.webApp[language]}</div>
              </div>
            </div>
            <Button className={"mx-0"} title={dictionary.installBtn[language]} onClick={(e)=>{navigate("/Help");}}/>
          </div>
        </div>
          </div>}
        <GameNavbar page={"home"}/>
        <div className={"rtl"}>
         <GameHeader type={HOME_ACTION_CLEAR}>
           <div className={"p-3 text-center d-flex flex-column justify-content-center align-items-center"}>
                           <div  dangerouslySetInnerHTML={{__html: dictionary.header[language]}} />
                          <Button onClick={scrollToGames} title={dictionary.viewGamesBtn[language]}></Button>

                        </div>
         </GameHeader>

          <div id={"games"} className='main_container'>

            { banners && banners.length> 0 && <div className={"container my-2"}>
              <Slider {...settings}>
                { banners.map((banner,index)=>
                {
                  return <div className="banner-container"><img key={`slide${index}`}
                              onClick={()=>{

                              if(banner.link && banner.link!="" )
                              { if(banner.link.indexOf("http")==-1)
                                 window.open(banner.link)

                                 else
                                 navigate("/WebView",{state:{url:banner.link , backUrl:"/"}})

                              }
                              else if(banner.action)
                              banner.action()


                              } }
                              className="slider-items" src={banner.url} alt="First slide" />
                              {banner.description && <p className="glow banner-description text-right rtl m-2">{banner.description}</p>}
                              </div>

                })
                }
               </Slider>

            </div>}



            { error==null && games==null   && <div
                className={`baziigramSpinner my-5 spinner-border text-light mx-auto d-block`}
                role="status"
            ></div>}
            {error && games==null && <div className={"text-center text-warning mt-5"}>{error}
            <Button onClick={loadGames} className={"mt-3"} title={dictionary.retry[language]}/>
            </div>}
            {categories && categories.length>0 && <div className={`${direction} new-grid-container`} >
             {categories.map(c=><button onClick={()=>updateState({category:c})}
             className={`${c.id==category.id ? "selected-game-category":"game-category"}`}>
             {c.name}</button>)}
              </div>}

            {  games && <>{Object.keys(games).map(key=>{
            if(Array.isArray(games[key])==false)
            return
            let list = games[key].filter(g=>g.category.id == category.id || category.id==0)
            if( list.length>0 && dictionary[key])
            return <><h2 className={`game-category-label-${language} mt-2`}>{dictionary[key][language]}</h2>
                   <div className={`${direction} new-grid-container`} >
                   {
                   list.map(game=>renderGameItem(game))
                    }
                    </div></>
            })}

            </>}


            <Footer />

          </div>


        </div>

      </GamePageLayout>
  )
}

export default IndexPage;
